import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { requestUploadFileAction } from "../../Redux/FileState/uploadFileActionCreator";

const FileUploadComponent = (props) => {
  const { accept, fileSave } = props;
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const dispatch = useDispatch();
  
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
    const file = event.dataTransfer.files[0];
    if (file && accept.includes(file.type)) {
      setSelectedFile(file);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleDeleteFile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedFile(null);
  };

  const uploadFile = () => {
    if (selectedFile) {
      fileSave(selectedFile)
    }
  };

  return (
    <div
      className="flex items-center justify-center w-full py-2"
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
    >
      <label
        htmlFor="dropzone-file"
        className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 
                dark:hover:bg-gray-800 dark:bg-gray-700 dark:border-gray-600
                dark:hover:border-gray-500 dark:hover:bg-gray-600 hover:bg-gray-light "
      >
        <div className="flex flex-col items-center justify-center pt-5 pb-6">
          <svg
            className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
            aria-hidden="true"
            fill="none"
            viewBox="0 0 20 16"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
            />
          </svg>
          <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
            <span className="font-semibold">
              Click to upload or drag and drop{" "}
            </span>
          </p>
          {selectedFile && (
            <div className="text-sm text-gray-500 flex dark:text-gray-400 mt-2 mr-2">
              Selected file:{" "}
              <span className="px-5 text-primary"> {selectedFile.name} </span>{" "}
              <button onClick={handleDeleteFile}>
                <svg
                  className="w-6 h-6 text-danger bg-red-500 rounded-full p-1"
                  aria-hidden="true"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M3 6h18v2H3V6zm2 3h14v12a2 2 0 01-2 2H7a2 2 0 01-2-2V9zm3 2v8h2v-8H8zm4 0v8h2v-8h-2zm4 0v8h2v-8h-2zM9 4V2h6v2h5v2H4V4h5z"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
        {selectedFile && (
          <div className="flex w-full justify-center">
            <button className="bg-primaryDark text-white rounded p-2" name="Upload" onClick={uploadFile}>upload</button>
          </div>
        )}
        <input
          id="dropzone-file"
          type="file"
          className="hidden"
          accept={accept.join(",")}
          onChange={handleFileChange}
        />
      </label>
    </div>
  );
};

export default FileUploadComponent;